import { useAppDispatch, useAppSelector } from '@/Application/Hooks/Redux';
import type {
  AccordionIndex,
  TPaymentMethodId
} from '@/modules/perseo-billing/components/accordion/interfaces';
import { useClearPaymentMethod } from '@/modules/perseo-billing/hooks';
import type { TactiveAccordion } from '@/modules/perseo-billing/store/slices/billing';
import { setActiveAccordion } from '@/modules/perseo-billing/store/slices/billing';

const createNewActiveAccordion = (
  methodId: TPaymentMethodId,
  indexes: AccordionIndex
): TactiveAccordion => {
  const newActiveAccordion: TactiveAccordion = {
    activeAccordionIndex: indexes.accordionIndex ?? undefined,
    activeItemIndex: indexes.itemIndex ?? undefined,
    accordionPaymentMethodId: methodId
  };

  return newActiveAccordion;
};

export const useAccordion = () => {
  const billing = useAppSelector((state) => state.billing);
  const dispatch = useAppDispatch();
  const { clearPayment } = useClearPaymentMethod();

  const getActiveItem = (indexes: AccordionIndex): boolean => {
    const { activeAccordion } = billing;
    if (!activeAccordion) return false;

    const { activeAccordionIndex, activeItemIndex } = activeAccordion;

    const isSameAccordion = activeAccordionIndex === indexes.accordionIndex;
    const isSameItem = activeItemIndex === indexes.itemIndex;

    const isSelected = isSameAccordion && isSameItem;
    return isSelected;
  };

  const handleSelected = () => {
    clearPayment();
    dispatch(setActiveAccordion(null));
  };

  const onHeaderClick = (
    indexes: AccordionIndex,
    methodId: TPaymentMethodId
  ) => {
    const isSelected = getActiveItem(indexes);

    // if its already selected then setActiveAccordion to null
    if (isSelected) {
      handleSelected();
      return;
    }

    const newActiveAccordion = createNewActiveAccordion(methodId, indexes);

    clearPayment();
    dispatch(setActiveAccordion(newActiveAccordion));
  };

  return {
    getActiveItem,
    onHeaderClick
  };
};
